import UserInfoPanel from './user-info-panel.vue'
UserInfoPanel.install = function (Vue) {
  Vue.component(UserInfoPanel.name, UserInfoPanel);
};
export default UserInfoPanel



// WEBPACK FOOTER //
// ./src/omnis-business/user-info-panel/index.js